export default __webpack_public_path__ + "static/media/5B2_08-09-18 The Big Boys a.ef530555.jpg";